
export default {
    name: "ChatMessage",
    props: {
        message: {
            required: true,
            type: String,
        },
        entityGetter: {
            required: false,
            type: Function,
        },
    },
    data() {
        return {
            htmlMessage: "",
            mentionPattern: /\[@b:([a-z-]+)\]/gi,
            emojiPattern: /\[@e:([A-Za-z0-9-]+)\]/gi,
        }
    },

    mounted() {
        this.htmlMessage = this.message
        // has @ mention
        const mentions = this.message.match(this.mentionPattern) || []
        for (let mention of mentions) {
            const entityData = mention.replace(this.mentionPattern, "$1")
            const company = this.entityGetter(entityData)
            // truncate mention name
            const companyName =
                company.text.length > 25
                    ? `${company.text.substring(0, 25)}...`
                    : company.text
            this.htmlMessage = this.message.replace(
                this.mentionPattern,
                `<span class="font-bold">${companyName}</span>`
            )
        }

        const emojis = this.htmlMessage.match(this.emojiPattern) || []
        for (let emoji of emojis) {
            const entityData = emoji.replace(this.emojiPattern, "$1")
            const emj = this.entityGetter(entityData)
            const emjName = emj.text
            let emojiLink = this.$store.getters["livestream/emojis"].find(
                (e) => e.name.toLowerCase() == emjName.toLowerCase()
            )?.image
            if (!emojiLink?.endsWith("=") && !emojiLink?.startsWith("/")) {
                emojiLink = "/" + emojiLink
            }
            const linkStr = `<img src="${emojiLink}" height="24px" class="emoji" />`
            const nameStr = `<span>:${emjName}:</span>`
            this.htmlMessage = this.htmlMessage.replace(
                `[@e:${emjName.toLowerCase()}]`,
                emojiLink ? linkStr : nameStr
            )
        }
        this.htmlMessage = `<span style="word-wrap: anywhere;" class="black--text">${this.htmlMessage}</span>`
    },
}
